import api from "@/api/axios";

const resource = "cars";

export default {
  // ==================== List ====================
  getAll(params = {}) {
    return api.get(`/${resource}`, { params }); // endpoint في باك إند بيرجع كل العربيات
  },
  getCars(params = {}) {
    return api.get(`/${resource}`, { params });
  },

  // ==================== Show ====================
  getCar(id, params = {}) {
    return api.get(`/${resource}/${id}`, { params });
  },

  // ==================== Create ====================
  // formData يجب أن يكون FormData عند الإرسال
  create(formData) {
    return api.post(`/${resource}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  // ==================== Update ====================
  update(id, formData) {
    return api.post(`/${resource}/${id}?_method=PUT`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  //  ==================== approve ====================
  approve(id) {
    return api.post(`/${resource}/${id}/approve`);
  },

  // ==================== Delete ====================
  delete(id) {
    return api.delete(`/${resource}/${id}`);
  },

  // ==================== Master Data ====================
  getMasterData() {
    return api.get("/cars/master-data");
  },

  // ==================== State Machine ====================
  changeStatus(id, status, reason = null) {
    return api.post(`/${resource}/${id}/status`, { status, reason });
  },

  bulkChangeStatus(carIds, status, reason = null) {
    return api.post(`/${resource}/status/bulk`, { car_ids: carIds, status, reason });
  },

  getStatusHistory(id) {
    return api.get(`/${resource}/${id}/status-history`);
  },

  undoBatch(batchUuid, reason = null) {
    return api.post('/status/undo', { batch_uuid: batchUuid, reason });
  },
};
